import React from 'react'
import styled from 'styled-components';

const PrimaryButton = ( { text, actionHandler }: any ) => {

    return (
        <PrimaryButtonWrapper>
            <button onClick = { ( e ) => actionHandler( e ) } > { text }</button>
        </PrimaryButtonWrapper>
    )
}

export default PrimaryButton;

const PrimaryButtonWrapper = styled.div`

    button {
        border: 3px solid blue;
        padding: 4px 10px;
        font-size: 20px;
        text-transform: uppercase;
        letter-spacing: 2px;
        background: transparent;
        font-weight: bolder;
    }

    button:hover {
        border: 4px solid green;
    }

`;
